import moment from 'moment';
import { $themeBreakpoints } from '@themeConfig';

import dateCeil from '@/xvisor/utilities/dateCeil';

const now = dateCeil(new Date());

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    zoneId: undefined,
    timeRange: { start: moment(now).subtract(6, 'hours').toDate(), end: now },
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state;
      if (windowWidth >= $themeBreakpoints.xl) return 'xl';
      if (windowWidth >= $themeBreakpoints.lg) return 'lg';
      if (windowWidth >= $themeBreakpoints.md) return 'md';
      if (windowWidth >= $themeBreakpoints.sm) return 'sm';
      return 'xs';
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay;
    },
    UPDATE_ZONE_ID(state, val) {
      state.zoneId = val;
    },
    UPDATE_TIME_RANGE(state, timeRange) {
      state.timeRange = timeRange;
    },
  },
  actions: {},
};
